/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (reports) => ({
	type: actions.REPORTS_RECEIVE,
	payload: { reports },
});